import React from "react";

const Blog4 = () => {
  return (
    <div>
      <div>
        <div>
          <div className="blog">
            <div className="row">
              <div className="col-md-9 article-area">
                <h2
                  style={{ marginTop: "85px" }}
                  className="mb-5 text-center project-title "
                >
                  Javascript HTML DOM Method
                </h2>
                <div style={{ justifyContent: "center" }} className="d-flex">
                  <img
                    className="img-fluid"
                    src="https://i.ibb.co/x8qDRw7/dom-in-js.jpg"
                    alt="css-flexbox"
                  />
                </div>
                <br />
                <article>
                  <p>
                    <b>The Javascript HTML DOM :</b>
                  </p>
                  <p>
                    The Javascript DOM is a method that allows scripts to
                    dynamically access the HTML and update the content,
                    structure, and style of a document.
                  </p>
                  <br />
                  <p>
                    The full meaning of <b>DOM</b> is Document Object Model. A
                    web page is a document which displays in the browser window.
                    The Dom is not part of Javascript. But it is manipulated by
                    JavaScript. We use Dom to select HTML elements.
                  </p>
                  <br />
                  <br />
                  <p>
                    DOM plays a very vital role in a modern website. It changes
                    the way of website interaction. By using dom we can select
                    an HTML element and can modify it by user interaction. We
                    can create elements and modify the elements and so on. DOM
                    gives us the power to modify a website into a nice web
                    application.
                  </p>
                  <br />
                  <br />
                  <p>
                    In modern web applications, there is a term called Virtual
                    DOM. It is like real dom but it works with XML or JSX. It
                    makes it easy for developers to select dom elements. The
                    virtual dom is a very intelligent mapping of DOM. It makes a
                    map of dom from the XML document and generates the real dom
                    accordingly. It changes the whole game.
                  </p>
                  <br />
                  <br />
                  <p>
                    <b>How do Real DOM works?</b>
                  </p>
                  <p>
                    The DOM method is not a hard task to understand. If we think
                    of a web page as a document and the root element is here the
                    HTML. Then we can select the document according to the
                    document model. We can select a document by its ID, Class
                    and event bubble, and so on. And After selecting the DOM we
                    can call in a Javascript function and can change and modify.
                  </p>
                  <br />
                  <br />
                  <p>
                    <b>How do virtual DOM works?</b>
                  </p>
                  <p>
                    The moral concepts of a DOM are basically the same as
                    selecting the document and modifying it. But it is not
                    similar things. The virtual dom is generally used with XML
                    or JSX. It is generally not used with real HTML markup.
                    Because the virtual dom is used in JSX to generate mapping
                    and apply the functionality. It is very easy to handle
                    because if we use virtual dom then we don’t need to select
                    the HTML elements via ID or Class. We can just use the XML
                    and put functions in it.
                  </p>
                </article>
              </div>
              {/*--------------- Adds section -------------- */}
              <div className="col-md-3">
                <img
                  style={{ marginTop: "70px" }}
                  src="https://i.ibb.co/HXcfLN6/9656093656252652900.gif"
                  alt=""
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog4;
